export default __webpack_public_path__ + "static/media/coin_bg.dcaf3188.mp4";